import PropTypes from 'prop-types'

const wizardsShape = PropTypes.shape({
  activeWizard: PropTypes.string,
  aStepsConfigurator: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string,
      isActive: PropTypes.bool
    })
  ).isRequired,
  aStepsStock: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string,
      isActive: PropTypes.bool
    })
  ).isRequired,
  aStepsTradeIn: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string,
      isActive: PropTypes.bool
    })
  ).isRequired
})

export default wizardsShape
